import React, { useRef, useState } from 'react';
import { useGlobal } from 'reactn';
//import useOnClickOutside from "hooks/useOnClickOutside";
import useOnclickOutside from "react-cool-onclickoutside";
import { SlideDown } from 'react-slidedown';

const RangeInputs = (props) => {

    const { feature } = props;

    const [rangeFilters, setRangeFilters] = useGlobal('rangeFilters');
    const [openSlider, setOpenSlider] = useGlobal('openSlider');

    // const sliderRef = useRef();
    // useOnClickOutside(sliderRef, () => setOpenSlider(null));
    const sliderRef = useOnclickOutside(() => setOpenSlider(''));

    const onSliderDD = (sliderId) => {
        if (openSlider === sliderId) {
            setOpenSlider('');
        } else {
            setOpenSlider(sliderId);
        }
    };
    const setMinValue = (e, id) => {
        const value = e.target.value;
        if (!value) {
            const clone = rangeFilters;
            if (rangeFilters[id] && !rangeFilters[id].max) {
                delete clone[id];
                setRangeFilters({ ...clone });
            } else {
                delete clone[id]['min'];
            }
            setRangeFilters({ ...clone });
        } else {
            setRangeFilters({ ...rangeFilters, [id]: { ...rangeFilters[id], min: value } });
        }
    }
    const setMaxValue = (e, id) => {
        const value = e.target.value;
        if (!value) {
            const clone = rangeFilters;
            if (rangeFilters[id] && !rangeFilters[id].min) {
                delete clone[id];
                setRangeFilters({ ...clone });
            } else {
                delete clone[id]['max'];
            }
            setRangeFilters({ ...clone });
        } else {
            setRangeFilters({ ...rangeFilters, [id]: { ...rangeFilters[id], max: value } });
        }
    }

    return (
        <div className="column-3 feature-filter-range">
            <div>
                <a className="filter-dd small" onClick={() => onSliderDD(feature.refRentalParameterId)}>
                    <div className='range-wrapper'>
                        <div className='range-label'>
                            {feature.RentalParameter_Name} {' '}
                        </div>
                        <div className='range-value'>
                            {rangeFilters[feature.refRentalParameterId]?.min} {' – '}
                            {rangeFilters[feature.refRentalParameterId]?.max}
                        </div>
                    </div>
                    <i className="fa fa-caret-down" aria-hidden="true"></i>
                </a>
            </div>
            <SlideDown className={'wy-dropdown'}>
                {(openSlider === feature.refRentalParameterId) &&
                    (<>
                        <span>{feature.RentalParameter_Name}</span>
                        <input style={{ width: `20%` }}
                            type="number"
                            placeholder={`Min. ${feature[`RentalParameter${feature.DataType_Name}FacetValue`][0].Min}`}
                            onChange={e => setMinValue(e, feature.refRentalParameterId)}
                            min={feature[`RentalParameter${feature.DataType_Name}FacetValue`][0].Min}
                            max={feature[`RentalParameter${feature.DataType_Name}FacetValue`][0].Max}
                            value={rangeFilters[feature.refRentalParameterId]?.min} />
                        <input style={{ width: `20%` }}
                            type="number"
                            placeholder={`Max. ${feature[`RentalParameter${feature.DataType_Name}FacetValue`][0].Max}`}
                            onChange={e => setMaxValue(e, feature.refRentalParameterId)}
                            min={feature[`RentalParameter${feature.DataType_Name}FacetValue`][0].Min}
                            max={feature[`RentalParameter${feature.DataType_Name}FacetValue`][0].Max}
                            value={rangeFilters[feature.refRentalParameterId]?.max} />
                    </>)}
            </SlideDown>
        </div>
    )
}

export default RangeInputs;